<!-- 河长 -->
<template>
    <MainLayout class="main-layout" :hasLeft="false" :hasRight="hasRight" rightWidth="320px">
        <News slot="header" :hasBack="true" :titleName="$t('home.news.back')" :subtitleName="''" @goBack="goBack">
        </News>
        <Middle ref="middle" slot="main" :hezhangList="hezhangList" :hezhangInfo="hezhangInfo" :photoList="photoList"
            :eventList="eventList" :mapConfig="mapConfig" :activityObj="activityObj"
            @changeSelectTime="changeSelectTime" :queryDate="selectTime" />
        <RightAside slot="right" :photoList="photoList" :eventList="eventList" :statisticsData="statisticsData"
            @bindType="bindType" @getEventList="(list) => { eventList = list; }" @bindTaskImg="getTaskImages"
            @bindPosition="getPosition" />
    </MainLayout>
</template>

<script>
import * as turf from '@turf/turf';
import { convertArrayToSelectTime } from '@Util';
import utils from '@/page/business/util/map.js';
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';
import RightAside from './components/RightAside.vue';
import Middle from './components/Middle.vue';
import Api from '../api/index.js';

import api from '@/page/DataMessage/api.js';

export default {
    components: {
        MainLayout,
        News,
        Middle,
        RightAside,
    },
    props: {},

    data () {
        return {
            eventInfoId: null,
            hasRight: true,

            mapConfig: {
                positionFitVal: [],
                positionVal: [],
                mapRange: 0.0008,
            },
            activityObj: {},
            // 河长列表
            hezhangList: [],
            // 网格信息列表
            hezhangInfoList: [],
            hezhangInfo: {},
            // 数据照片列表
            photoList: [],
            // 数据事件列表
            eventList: [],

            queryDate: [],
            selectTime: [],
            routeObj: {},
            statisticsData: {
                list: [],
                listType: 0,
            },
        };
    },
    watch: {
        '$route.query': {
            handler (newVal) {
                // 获取当前 URL 的查询字符串
                this.routeObj = newVal || { dataId: '', type: '' };

                if (newVal.queryDate) {
                    let arr = JSON.parse(newVal.queryDate);
                    let times = convertArrayToSelectTime(arr);
                    Object.assign(this.queryDate, arr);
                    Object.assign(this.selectTime, times);
                }
                if (newVal.type) {
                    this.statisticsData.listType = newVal.type === 'img' ? 1 : 0;
                }
                if (this.routeObj.dataId) {
                    this.getDataDetail(this.routeObj.dataId);
                    this.getRiverLakeIslandList();
                    this.getProjectList();
                    this.getStatisticsBy(this.routeObj.dataId);
                }
            },
            immediate: true,
            deep: true,
        },
        queryDate: {
            handler (newVal) {
                if (this.routeObj.dataId && newVal.length > 0) {
                    this.getDataDetail(this.routeObj.dataId);
                    this.getStatisticsBy(this.routeObj.dataId);
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {},
    methods: {
        bindType (val) {
            this.statisticsData.listType = val;
        },
        // 河长返回首页
        goBack () {
            this.$router.push({ path: '/hezhang/index' });
        },

        getPosition (val) {
            // console.log('获取位置', val);
            this.mapConfig.positionVal = [val.longitude, val.latitude];
            this.activityObj = val;
        },

        changeSelectTime (times) {
            this.queryDate = times;
        },

        // 查询图片列表
        async getLatestImages (id) {
            this.photoList = [];
            let params = {
                objectId: id,
                beginTime: this.queryDate[0],
                endTime: this.queryDate[1],
                // 'params[beginTime]': this.queryDate[0],
                // 'params[endTime]': this.queryDate[1],
            };
            let ref = await Api.hzDataPicture(params);
            if (ref.code === 200) {
                this.photoList = ref.data;
            } else {
                this.$message.error(ref.msg);
            }
        },
        // 获取事件列表
        async getLatestEvent (id) {
            this.eventList = [];
            let params = {
                objectId: id,
                beginTime: this.queryDate[0],
                endTime: this.queryDate[1],
                // 'params[beginTime]': this.queryDate[0],
                // 'params[endTime]': this.queryDate[1],
            };
            let ref = await Api.hzDataEvent(params);
            if (ref.code === 200) {
                // console.log('事件列表', ref.data);
                this.eventList = ref.data;
            } else {
                this.$message.error(ref.msg);
            }
        },

        // 获取任务图片列表
        async getTaskImages (id) {
            let params = { taskId: id };
            this.photoList = [];
            await api.getPictureList(params).then((res) => {
                if (res.code === 200 && res.total > 0) {
                    this.photoList = res.rows;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        /**
         * 获取数据详细信息
         *
         * @param id 数据ID
         * @returns 无返回值
         */
        async getDataDetail (id, type) {
            let ref = null;
            if (type === 'PROJECT') {
                ref = await Api.projectInfo(id);
            } else {
                ref = await Api.waterAreaInfo(id);
            }

            if (ref.code === 200) {
                this.activityObj = ref.data;
                this.getPositionFitVal(ref.data.geometry, this.mapConfig.mapRange);
                this.hezhangInfo = {
                    ...ref.data,
                };
                this.photoList = [];
                this.getLatestImages(id);
                this.getLatestEvent(id);
            } else {
                this.$message.error(ref.msg);
            }
        },

        /**
         * 获取地图适配值和中心点坐标
         *
         * @param {string} geometry - 几何文本，描述多边形或多边形的集合
         * @param {number} range - 范围值，用于调整地图中心点坐标
         */
        getPositionFitVal (geometry, range) {
            this.hasRight = range !== 0.002;
            let polList = utils.parseMultiPolygon(geometry, this.getWktType(geometry));
            let PolygonCoords = utils.closePolygonCoords([polList]);
            let polygon = turf.polygon(PolygonCoords);
            // 计算质心
            let polygonCenter = turf.centroid(polygon);
            let objList1 = [];
            let objList2 = [];
            polList.forEach((item) => {
                objList1.push(item[0]);
                objList2.push(item[1]);
            });

            let maxLng = Math.max.apply(null, objList1);
            let minLng = Math.min.apply(null, objList1);
            let maxLat = Math.max.apply(null, objList2);
            let minLat = Math.min.apply(null, objList2);
            let center = [minLng, minLat - range, maxLng, maxLat + range];
            this.mapConfig.positionFitVal = center;
            this.mapConfig.positionVal = polygonCenter.geometry.coordinates;
        },
        // 解析WKT类型
        getWktType (val) {
            let type = 'Polygon';
            if (val.indexOf('MULTIPOLYGON') > -1) {
                type = 'MULTIPOLYGON';
            } else if (val.indexOf('POLYGON') > -1) {
                type = 'Polygon';
            }
            return type;
        },

        /**
         * 获取河湖岛列表：
         *
         * @returns {Promise<Array>} 返回一个包含任务列表的Promise对象
         */
        getRiverLakeIslandList () {
            let param = {
                'params[beginTime]': this.queryDate[0],
                'params[endTime]': this.queryDate[1],
            };
            Api.riverLakeIslandList(param).then((res) => {
                if (res.code === 200) {
                    let list = res.rows || [];
                    // console.log('获取河湖岛列表：', list);
                    this.hezhangList = [...list, ...this.hezhangList];
                    // this.heHuIslandObj = { list, total: res.total };
                }
            });
        },
        /**
         * 获取工程列表：
         *
         * @returns {Promise<Array>} 返回一个包含获取工程列表：的Promise对象
         */
        getProjectList () {
            let param = {
                'params[beginTime]': this.queryDate[0],
                'params[endTime]': this.queryDate[1],
            };
            Api.projectList(param).then((res) => {
                if (res.code === 200) {
                    let list = res.rows || [];
                    this.hezhangList = [...this.hezhangList, ...list];
                }
            });
        },
        // 分页查询河湖岛工程
        getHeHuIslandProject () {
            this.getRiverLakeIslandList();
            this.getProjectList();
        },
        // 统计接口
        getStatisticsBy (id) {
            let param = {
                objectId: id,
                beginTime: this.queryDate[0],
                endTime: this.queryDate[1],
            };
            Api.hzStatistics(param).then((res) => {
                if (res.code === 200) {
                    this.statisticsData.list = res.data || [];
                }
            });
        },

    },
    mounted () {
        const queryString = this.$route.query;
        this.routeObj = queryString;
        // if (this.routeObj.taskId) {
        //     let id = this.routeObj.taskId;
        //     this.getTaskImages(id);
        // }
        // if (this.routeObj.gridId) {
        //     let id = this.routeObj.gridId;
        //     this.getGridUnitDetail(id);
        // }
    },
};
</script>

<style lang="scss" scoped>
.main-layout {
    height: calc(100% - 16px);
    padding: 0px 8px;
}
</style>
